import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_org/org/$orgId/team/roles/")({
  beforeLoad: () => {
    throw redirect({ to: "/org/providers" });
  },
});
